import { Controller } from '@hotwired/stimulus';
import * as clipboard from 'clipboard-polyfill';

export default class ShareController extends Controller {
  static targets = ['button'];

  static values = {
    url: String,
    title: String
  };

  shareLink() {
    if (navigator.share) {
      navigator
        .share({
          url: this.urlValue,
          title: this.titleValue
        })
        .catch(console.error);
    } else {
      clipboard.writeText(this.urlValue).then(
        () => {
          this.buttonTarget.innerText = 'Copied!';
          setTimeout(() => {
            this.buttonTarget.innerText = 'Copy';
          }, 5000);
        },
        (e) => {
          console.error(`Error copying to clipboard: ${e}`);
        }
      );
    }
  }

  copy() {
    clipboard.writeText(this.urlValue).then(
      () => {
        this.buttonTarget.innerText = 'Copied!';
        setTimeout(() => {
          this.buttonTarget.innerText = 'Copy';
        }, 5000);
      },
      (e) => {
        console.error(`Error copying to clipboard: ${e}`);
      }
    );
  }
}
